import { registerComponent } from "react_mount"

registerComponent("profile-newsletters-page", () => import("containers/ProfileNewslettersIndex"))
